const ro = {
	Credentials: "Certificate",
	Logout: "Delogare",
	"My Credentials": "Certificatele mele",
	"Issue Date": "Data emiterii",
	By: "De catre",
	View: "Vizualizare",
	Verify: "Verificare",
	purchase_for: "Cumpara pentru ",
	"Terms of Service": "Termeni si Conditii",
	"Privacy & Data Protection": "Confidentialitatea & Protectia datelor",
	"Customer Support": "Relatii Clienti",
	"Help Center": "Centru de ajutor",
	"Verify Certificate": "Verifica Certificatul",
	"View Certificate": "Vizualizeaza Certificatul",
	Inbox: "Inbox",
	"Open Issuers App": "Aplicația Emitenți",
	Name: "Nume",
	"You are purchasing": "Cumparati",
	"Payment info": "Informatii despre plata",
	Email: "Email",
};
export default ro;
